var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
    fill: "#BF1E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40699 5.88608V13.4H7.23338V5.88608H9.40699ZM7.10144 3.94164C7.10144 3.62682 7.21255 3.36988 7.43477 3.1708C7.65699 2.9671 7.94866 2.86525 8.30977 2.86525C8.67088 2.86525 8.96255 2.9671 9.18477 3.1708C9.41162 3.36988 9.52505 3.62682 9.52505 3.94164C9.52505 4.25182 9.41162 4.50877 9.18477 4.71247C8.96255 4.91154 8.67088 5.01108 8.30977 5.01108C7.94866 5.01108 7.65699 4.91154 7.43477 4.71247C7.21255 4.50877 7.10144 4.25182 7.10144 3.94164Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveInfo);
export default __webpack_public_path__ + "static/media/active-info.7362ffda5f2191a2f059f268f8f05fde.svg";
export { ForwardRef as ReactComponent };